import { applyMiddleware, compose, createStore } from 'redux';
import Reducers from './reducer';
import { thunk } from 'redux-thunk';

// ==============================|| REDUX - MAIN STORE ||============================== //

// CREATE STORE
const store = createStore(Reducers, compose(applyMiddleware(thunk)));


const persister = 'Free';

export { store, persister };
